import { render, staticRenderFns } from "./ViewAttachmentModal.vue?vue&type=template&id=1d870212&scoped=true"
import script from "./ViewAttachmentModal.vue?vue&type=script&lang=js"
export * from "./ViewAttachmentModal.vue?vue&type=script&lang=js"
import style0 from "./ViewAttachmentModal.vue?vue&type=style&index=0&id=1d870212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d870212",
  null
  
)

export default component.exports